/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";
import { useParams, useNavigate } from "react-router-dom";
import {
  getDoctorLoanById,
  updateDoctorLoan,
  getAllAdmins,
  getAllCities,
  getAllStates,
  getAllPincode,
  getDoctorLoanByEmail,
  getDoctorLoanByMobile,
  getDoctorLoanBankList
} from "../../../middleware/backend_hepler";
import LabeledInput from "../../../components/LabeledInput";
import LabeledSelect from "../../../components/LabeledSelect";
import LabeledSelectAgent from "../../../components/LabeledSelectAgent";
import LabeledDropDown from "../../../components/LabeledDropDown";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { useForm, FormProvider } from "react-hook-form";
import { validationRules, validateDOB } from "../../../utils/validationRules";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaTrashAlt } from "react-icons/fa";


const EditDoctorLoan = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [error, setError] = useState(null);
  const [mobileExists, setMobileExists] = useState(false);
  const [emailExists, setEmailExists] = useState(false);
  const [initialEmail, setInitialEmail] = useState("");
  const [initialMobile, setInitialMobile] = useState("");
  const { adminRole, adminName, adminId } = useContext(AuthContext);
  const [status, setStatus] = useState("");
  const [filteredStates, setFilteredStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [presentState, setPresentState] = useState(null);
  const [presentCityOptions, setPresentCityOptions] = useState([]);
  const [presentPincodeOptions, setPresentPincodeOptions] = useState([]);
  const [clinicState, setClinicState] = useState(null);
  const [clinicCityOptions, setClinicCityOptions] = useState([]);
  const [clinicPincodeOptions, setClinicPincodeOptions] = useState([]);
  const [hospitalState, setHospitalState] = useState(null);
  const [hospitalCityOptions, setHospitalCityOptions] = useState([]);
  const [hospitalPincodeOptions, setHospitalPincodeOptions] = useState([]);
  const [doctorLoanBanks, setDoctorLoanBanks] = useState([]);
  const [files, setFiles] = useState({});

  const fileRefs = {
    pan_card: useRef(null),
    aadhar_card: useRef(null),
    photo: useRef(null),
    payslip: useRef(null),
    salaried_account_statement: useRef(null),
    itr: useRef(null),
    degree_certificate: useRef(null),
    others: useRef(null),
    ima_certificate: useRef(null),
    clinic_registration_certificate: useRef(null),
  };

  const steps = ["Personal Details", "Income Details", "Upload Documents"];

  const methods = useForm({
    defaultValues: {
        created_id: "",
        created_by: "",
        assigned_to: "",
        status: "",
        rejected_reason: "",
        name: "",
        dob: "",
        age: "",
        mobile: "",
        email: "",
        father_name: "",
        mother_name: "",
        marital_status: "",
        spouse_name: "",
        residence_type: "",
        address: "",
        landmark: "",
        state: "",
        city: "",
        pincode: "",
        current_address_as_per_aadhar: "",
        present_address: "",
        present_state: "",
        present_city: "",
        present_pincode: "",
        required_loan_amount: "",
        existing_emi_amount: "",
        degree: "",
        service_experience: "",
        mbbs_completed_year: "",
        degree_others: "",
        work_type: "",
        clinic_name: "",
        clinic_address: "",
        clinic_state: "",
        clinic_city: "",
        clinic_pincode: "",
        hospital_name: "",
        total_experience: "",
        net_salary: "",
        is_pf_deducted: "",
        hospital_address: "",
        hospital_state: "",
        hospital_city: "",
        hospital_pincode: "",
        add_reference: "",
        reference_name: "",
        reference_mobile: "",
        reference_address: "",
        reference_location: "",
        bank_name: "",
        pan_card: null,
        aadhar_card: null,
        photo: null,
        payslip: null,
        salaried_account_statement: null,
        itr: null,
        degree_certificate: null,
        others: null,
        ima_certificate: null,
        clinic_registration_certificate: null,
    },
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = methods;
  const email = watch("email");
  const mobile = watch("mobile");
  const maritalStatus = watch("marital_status");
  const loanStatus = watch("status");
  const presentAddressAadhar = watch("current_address_as_per_aadhar") ;
  const dob = watch('dob');
  const selectedStatus = watch("status");

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setFilteredStates(availableStates);
      } catch (error) {
        console.error("Error fetching states data:", error);
      }
    };
    fetchStates();
  }, []);

  const stateOptions = filteredStates.map((state) => ({
    value: state.name,
    label: state.name,
  }));

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await getAllCities();
        citiesData.sort((a, b) => a.name.localeCompare(b.name));
        setCities(citiesData);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    const fetchPinCode = async () => {
      try {
        const pincodeData = await getAllPincode();
        setPincode(pincodeData);
      } catch (error) {
        console.error("Error fetching pincodes:", error);
      }
    };
    fetchPinCode();
  }, []);

  useEffect(() => {
    if (!selectedState) {
      setCityOptions([]);
      setPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === selectedState
      );

      const cityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setCityOptions(cityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === selectedState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPincodeOptions(uniqueOptions);
    }

    if (!presentState) {
      setPresentCityOptions([]);
      setPresentPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === presentState
      );

      const presentCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setPresentCityOptions(presentCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === presentState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPresentPincodeOptions(uniqueOptions);
    }

    if (!clinicState) {
      setClinicCityOptions([]);
      setClinicPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === clinicState
      );

      const clinicCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setClinicCityOptions(clinicCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === clinicState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setClinicPincodeOptions(uniqueOptions);
    }

    if (!hospitalState) {
      setHospitalCityOptions([]);
      setHospitalPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === hospitalState
      );

      const hospitalCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setHospitalCityOptions(hospitalCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === hospitalState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setHospitalPincodeOptions(uniqueOptions);
    }
  }, [
    selectedState,
    presentState,
    clinicState,
    hospitalState,
    cities,
    pincodenumber,
  ]);

  useEffect(() => {
    const fetchDoctorLoanBanks = async () => {
      try {
        const response = await getDoctorLoanBankList();
        const banksData = response.data.map(bank => ({
          value: bank.bank_name,
          label: bank.bank_name
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setDoctorLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching doctor loan banks:", error);
      }
    };
    fetchDoctorLoanBanks();
  }, []);

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption?.value || null);
    setValue("state", selectedOption?.value || "");
  };

  const getSelectedStateValue = () => {
    return stateOptions.find((option) => option.value === selectedState);
  };

  const handlePresentStateChange = (selectedOption) => {
    setPresentState(selectedOption?.value || null);
    setValue("present_state", selectedOption?.value || "");
  };

  const getSelectedPresentStateValue = () => {
    return stateOptions.find((option) => option.value === presentState);
  };

  const handleClinicStateChange = (selectedOption) => {
    setClinicState(selectedOption?.value || null);
    setValue("clinic_state", selectedOption?.value || "");
  };

  const getSelectedClinicStateValue = () => {
    return stateOptions.find((option) => option.value === clinicState);
  };

  const handleHospitalStateChange = (selectedOption) => {
    setHospitalState(selectedOption?.value || null);
    setValue("hospital_state", selectedOption?.value || "");
  };

  const getSelectedHospitalStateValue = () => {
    return stateOptions.find((option) => option.value === hospitalState);
  };

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await getAllAdmins();
        const filteredEmployees = response.filter(
          (admin) => admin.role === "employee"
        );
        setEmployees(filteredEmployees);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  useEffect(() => {
    const fetchLoanData = async () => {
      try {
        const loan = await getDoctorLoanById(id);
        Object.keys(loan).forEach((key) => {
          setValue(key, loan[key]);
        });
        setInitialEmail(loan.email);
        setInitialMobile(loan.mobile);
        setSelectedState(loan.state);
        setPresentState(loan.present_state);
        setHospitalState(loan.hospital_state);
        setClinicState(loan.clinic_state);
      } catch (error) {
        console.error("Error fetching doctor loan data:", error);
      }
    };

    fetchLoanData();
  }, [id, setValue]);

  const checkEmail = async (email) => {
    if (email && email !== initialEmail) {
      try {
        const data = await getDoctorLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    } else {
      setEmailExists(false);
    }
  };

  const checkMobile = async (mobile) => {
    if (mobile && mobile !== initialMobile) {
      try {
        const data = await getDoctorLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    } else {
      setMobileExists(false);
    }
  };

  useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  useEffect(() => {
    if (dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (
        monthDifference < 0 ||
        (monthDifference === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      if (age >= 0) {
        setValue("age", age);
      } else {
        setValue("age", "");
      }
    }
  }, [dob, setValue]);

  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    const initials = names.map((n) => n.charAt(0).toUpperCase()).join("");
    return initials;
  };

  const employeeOptions = employees.map((employee) => ({
    value: `ID${employee.id} - ${employee.name}`,
    label: (
      <div className="agent-option">
        {employee.photo ? (
          <img
            src={decodeURIComponent(employee.photo)}
            alt={`${employee.name}'s avatar`}
            className="agent-image"
          />
        ) : (
          <div className="agent-image-initials">{getInitials(employee.name)}</div>
        )}
        <span className="agent-details">
          <strong>ID{employee.id}</strong> - {employee.name}
        </span>
      </div>
    ),
  }));

  const onSubmit = async (data) => {
    setLoading(true);
    const formDataToSend = new FormData();
    Object.keys(data).forEach((key) => {
      if (data[key]) {
        formDataToSend.append(key, data[key]);
      }
    });

    try {
      await updateDoctorLoan(id, formDataToSend);
      setLoading(false);
      navigate("/doctorloanlist", {
        state: { successMessage: "Doctor loan updated successfully!" },
      });
    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message;

      if (typeof errorMessage === "string") {
        if (errorMessage.includes("Email already exists")) {
          toast.error("Email already exists. Please use a different email.");
        }
        if (errorMessage.includes("Mobile number already exists")) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
        }
        if (errorMessage.includes("Mobile number or email already exists")) {
          toast.error(
            "Mobile number or email already exists. Please use different details."
          );
        }
      } else {
        setLoading(false);
        console.error("Error updating doctor loan:", error);
        toast.error("Failed to update the doctor loan. Please try again.");
      }
    }
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (files.length > 0) {
      setValue(name, files[0]);
      setFiles((prev) => ({
        ...prev,
        [name]: files.length > 0 ? files[0] : null,
      }));
    }
  };

  const handleClearFile = (name) => {
    if (fileRefs[name] && fileRefs[name].current) {
      fileRefs[name].current.value = null;
      setFiles((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleViewClick = async (documentType) => {
    try {
      const loan = await getDoctorLoanById(id);
      const documentUrl = loan[documentType]
        ? decodeURIComponent(loan[documentType])
        : null;

      if (documentUrl) {
        window.open(documentUrl, "_blank");
      } else {
        toast.warn(`No file available`);
        console.error(`No ${documentType} document found for this loan.`);
      }
    } catch (error) {
      console.error(`Error fetching ${documentType} document:`, error);
    }
  };
  
  const handleDownloadClick = async (documentType) => {
    try {
      const loan = await getDoctorLoanById(id);
      let url = loan[documentType];

      if (!url) {
        toast.warn("No file available");
        return;
      }

      url = decodeURIComponent(url);

      // Auto-upgrade to HTTPS in production
      if (window.location.hostname !== "localhost" && url.startsWith("http://")) {
        url = url.replace("http://", "https://");
      }

      // Fetch blob if local or same-origin, otherwise direct link download
      const isLocalOrSameOrigin = url.startsWith(window.location.origin) || window.location.hostname === "localhost";

      if (isLocalOrSameOrigin) {
        const response = await fetch(url);
        if (!response.ok) throw new Error("Failed to fetch the document");
        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `${documentType}_${id}`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

      } else {
        // Cross-origin server file
        const link = document.createElement("a");
        link.href = url;
        const fileName = url.split("/").pop() || `${documentType}_${id}`;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

    } catch (error) {
      console.error(`Error downloading ${documentType} document:`, error);
      toast.error("Failed to download document");
    }
  };

  const handleStepChange = async (newStep) => {
    if (newStep === 1) {
      const isValidStep0 = await methods.trigger();
      if (isValidStep0) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }
        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else if (newStep === 2) {
      const isValidStep1 = await methods.trigger();
      if (isValidStep1) {
        setActiveStep(newStep);
      } else {
        console.log(
          "Please fix validation errors before moving to the next step."
        );
      }
    } else {
      setActiveStep(newStep);
    }
  };
  
  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="edit-all-loan-container">
      {activeStep === 0 && (
        <div className="edit-back-icon">
          <div
            className="edit-back-text"
            onClick={() => navigate("/doctorloanlist")}
          >
            &lt; Go Back
          </div>
        </div>
      )}
      <h2>Doctor Loan</h2>
      <FormProvider {...methods}>
        {loading}
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <Row>
                  <Col md={6}>
                    <LabeledInput
                      label="Loan ID"
                      name="form_id"
                      disabled={true}
                      style={{
                        backgroundColor: "#f0f0f0",
                        color: "#808080",
                      }}
                      registerOptions={{}}
                    />
                  </Col>
                  {adminRole !== "customer" && ( 
                    <>
                      <Col md={6}>
                        <LabeledInput
                          label="Employee ID"
                          name="created_id"
                          disabled={true}
                          style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          label="Employee"
                          name="created_by"
                          disabled={true}
                          style={{ backgroundColor: "#f0f0f0", color: "#808080" }}
                        />
                      </Col>
                    </>
                  )}
                  {adminRole === "admin" && (
                    <Col md={6}>
                      <LabeledSelect
                        name="assigned_to"
                        label="Assign to"
                        options={employeeOptions}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.assigned_to?.message}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      name="status"
                      label="Lead Status"
                      options={[
                        { value: "Open", label: "Open" },
                        { value: "In Process", label: "In Process" },
                        { value: "Pending", label: "Pending" },
                        { value: "Approved", label: "Approved" },
                        { value: "Rejected", label: "Rejected" },
                      ]}
                      registerOptions={{
                        required: "Selection is required",
                        onChange: (e) => {
                          handleStatusChange(e);
                          setValue("status", e.target.value);
                        },
                      }}
                      disabled={adminRole === "customer"}
                      error={errors.status?.message}
                      required
                    />
                  </Col>
                  {loanStatus === "Rejected" && (
                    <Col md={6}>
                      <LabeledDropDown
                        name="rejected_reason"
                        label="Rejected Reason"
                        options={[
                          {
                            value: "CIBIL issue & more than 3 enquiries",
                            label: "CIBIL issue & more than 3 enquiries",
                          },
                          {
                            value: "Recent loan/settlement",
                            label: "Recent loan/settlement",
                          },
                          { value: "Recent DPD", label: "Recent DPD" },
                          {
                            value: "Overdue / Previous loan (HL/PL/BL/CL)",
                            label: "Overdue / Previous loan (HL/PL/BL/CL)",
                          },
                          {
                            value: "Lowest CIBIL score",
                            label: "Lowest CIBIL score",
                          },
                          {
                            value: "Pincode / Salary / Age criteria not met",
                            label: "Pincode / Salary / Age criteria not met",
                          },
                          {
                            value: "Can apply after 3 months",
                            label: "Can apply after 3 months",
                          },
                          {
                            value: "Never eligible for loan",
                            label: "Never eligible for loan",
                          },
                          {
                            value: "Credit card overdue",
                            label: "Credit card overdue",
                          },
                        ]}
                        registerOptions={{ required: "Selection is required" }}
                        error={errors.rejected_reason?.message}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledInput
                      label="Name"
                      type="text"
                      name="name"
                      registerOptions={validationRules.name}
                      error={errors.name?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Date of Birth"
                      type="date"
                      name="dob"
                      registerOptions={{
                        required: "Date of Birth is required",
                        validate: validateDOB,
                      }}
                      error={errors.dob?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Age"
                      type="number"
                      name="age"
                      readOnly
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Mobile"
                      type="tel"
                      name="mobile"
                      registerOptions={validationRules.mobile}
                      error={errors.mobile?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      label="Email"
                      type="text"
                      name="email"
                      registerOptions={validationRules.email}
                      error={errors.email?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="father_name"
                      label="Father Name"
                      registerOptions={validationRules.name}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="mother_name"
                      label="Mother Name"
                      registerOptions={validationRules.name}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="marital_status"
                      label="Marital Status"
                      options={[
                        { value: "single", label: "Single" },
                        { value: "married", label: "Married" },
                        { value: "divorced", label: "Divorced" },
                      ]}
                      registerOptions={{
                        required: "Status is required",
                        onChange: (e) => {
                          setValue("marital_status", e.target.value);
                        },
                      }}
                      error={errors.marital_status?.message}
                    />
                  </Col>
                  {maritalStatus === "married" && (
                    <Col md={6}>
                      <LabeledInput
                        name="spouse_name"
                        label="Spouse Name"
                        registerOptions={validationRules.name}
                        required
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      name="residence_type"
                      label="Residence Type"
                      options={[
                        {
                          value: "OwnedByMe/Spouse",
                          label: "OwnedByMe/Spouse",
                        },
                        {
                          value: "OwnedByMy/Parents",
                          label: "OwnedByMy/Parents",
                        },
                        { value: "Rent", label: "Rent" },
                        { value: "PG", label: "PG" },
                        { value: "Hostel", label: "Hostel" },
                        { value: "Bachelor", label: "Bachelor" },
                        { value: "Company_Provided", label: "Company Provide" },
                      ]}
                      registerOptions={{
                        required: "Residence type is required",
                      }}
                      error={errors.residence_type?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="address"
                      label="Present Staying Address"
                      registerOptions={{
                        required: "Address is required",
                      }}
                      error={errors.address?.message}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="landmark"
                      type="text"
                      label="Landmark"
                      registerOptions={{ required: "Landmark is required" }}
                      required
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelect
                      name="state"
                      label="State"
                      options={stateOptions}
                      value={getSelectedStateValue()}
                      registerOptions={{ required: "State is required" }}
                      onChange={handleStateChange}
                      error={errors.state?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelect
                      name="city"
                      label="City"
                      options={cityOptions}
                      registerOptions={{ required: "City is required" }}
                      error={errors.city?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledSelectAgent
                      name="pincode"
                      label="Pincode"
                      options={pincodeOptions}
                      registerOptions={{ required: "Pincode is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledDropDown
                      name="current_address_as_per_aadhar"
                      label="Is your Present Address as per Aadhaar"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{
                        required: "This selection is required",
                      }}
                      error={errors.current_address_as_per_aadhar?.message}
                      required
                    />
                  </Col>
                  {presentAddressAadhar === "No" && (
                    <Col md={6}>
                      <LabeledInput
                        label="Present Address"
                        type="text"
                        name="present_address"
                        error={errors.present_address?.message}
                      />
                    </Col>
                  )}
                  {presentAddressAadhar === "No" && (
                    <>
                      <Col md={6}>
                        <LabeledSelect
                          name="present_state"
                          label="Present State"
                          options={stateOptions}
                          value={getSelectedPresentStateValue()}
                          onChange={handlePresentStateChange}
                          error={errors.present_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="present_city"
                          label="Present City"
                          options={presentCityOptions}
                          error={errors.present_city?.message}
                        />
                      </Col>
                    </>
                  )}
                  {presentAddressAadhar === "No" && (
                    <>
                      <Col md={6}>
                        <LabeledSelectAgent
                          name="present_pincode"
                          label="Present Pincode"
                          options={presentPincodeOptions}
                          error={errors.present_pincode?.message}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            )}

            {activeStep === 1 && (
              <div className="sections project-details-sections">
                <h4>Income Details</h4>
                <Row>
                  <Col md={6}>
                    <LabeledInput
                      name="required_loan_amount"
                      label="Required Loan Amount"
                      type="number"
                      registerOptions={validationRules.loanAmount}
                      required
                      error={errors.required_loan_amount?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="existing_emi_amount"
                      label="Existing EMI"
                      type="number"
                      registerOptions={{
                        required: "This Existing EMI is required",
                      }}
                      required
                      error={errors.existing_emi_amount?.message}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <LabeledDropDown
                      name="degree"
                      label="Choose Degree"
                      options={[
                        { value: "MBBS", label: "MBBS" },
                        { value: "MD&Above", label: "MD & Above" },
                        { value: "Surgeon", label: "Surgeon" },
                        { value: "BDS/MDS", label: "BDS/MDS" },
                        { value: "Others", label: "Others" },
                      ]}
                      registerOptions={{
                        required: "This selection is required",
                      }}
                      error={errors.degree?.message}
                    />
                  </Col>
                  {adminRole !==  "customer" &&(
                    <Col md={6}>
                      <LabeledSelect
                        name="bank_name"
                        label="Bank Name"
                        options={doctorLoanBanks}
                      />
                    </Col>
                  )}

                  {watch("degree") === "MBBS" && (
                    <>
                      <Col md={6}>
                        <LabeledInput
                          name="service_experience"
                          label="Service Experience"
                          registerOptions={{
                            required: "Service experience is required",
                          }}
                          error={errors.spouse_name?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="mbbs_completed_year"
                          label="MBBS Completed Year"
                          type="number"
                          registerOptions={{
                            required: "MBBS Completed Year is required",
                            validate: (value) => {
                              const currentYear = new Date().getFullYear();
                              if (
                                isNaN(value) ||
                                value < 1990 ||
                                value >= currentYear
                              ) {
                                return `Please enter a year between 1990 and ${
                                  currentYear - 1
                                }`;
                              }
                              return true;
                            },
                          }}
                          error={errors.mbbs_completed_year?.message}
                        />
                      </Col>
                    </>
                  )}

                  {watch("degree") === "Others" && (
                    <Col md={6}>
                      <LabeledInput
                        name="degree_others"
                        label="Degree Others"
                        registerOptions={{
                          required: "Degree others is required",
                        }}
                        error={errors.degree_others?.message}
                      />
                    </Col>
                  )}

                  <Col md={6}>
                    <LabeledDropDown
                      name="work_type"
                      label="Work Type?"
                      options={[
                        { value: "Salaried", label: "Salaried" },
                        { value: "Own Clinic", label: "Own Clinic" },
                      ]}
                      registerOptions={{
                        required: "This selection is required",
                      }}
                      error={errors.work_type?.message}
                    />
                  </Col>

                  {watch("work_type") === "Own Clinic" && (
                    <>
                      <Col md={6}>
                        <LabeledInput
                          name="clinic_name"
                          label="Clinic Name"
                          registerOptions={{
                            required: "Clinic name is required",
                          }}
                          required
                          error={errors.clinic_name?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="clinic_address"
                          label="Clinic Address"
                          registerOptions={{
                            required: "Clinic address is required",
                          }}
                          required
                          error={errors.clinic_address?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="clinic_state"
                          label="Clinic State"
                          options={stateOptions}
                          value={getSelectedClinicStateValue()}
                          onChange={handleClinicStateChange}
                          registerOptions={{ required: "State is required" }}
                          error={errors.clinic_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="clinic_city"
                          label="Clinic City"
                          options={clinicCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.clinic_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelectAgent
                          name="clinic_pincode"
                          label="Clinic Pincode"
                          options={clinicPincodeOptions}
                          registerOptions={{ required: "Pincode is required" }}
                          error={errors.clinic_pincode?.message}
                        />
                      </Col>
                    </>
                  )}

                  {watch("work_type") === "Salaried" && (
                    <>
                      <Col md={6}>
                        <LabeledInput
                          name="hospital_name"
                          label="Working Hospital Name"
                          registerOptions={{
                            required: "Hospital name is required",
                          }}
                          required
                          error={errors.hospital_name?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="total_experience"
                          label="Total Experience"
                          registerOptions={{
                            required: "Total experience is required",
                          }}
                          required
                          error={errors.total_experience?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="net_salary"
                          label="Net Salary"
                          type="number"
                          registerOptions={{
                            required: "Net salary is required",
                          }}
                          required
                          error={errors.net_salary?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledDropDown
                          name="is_pf_deducted"
                          label="Are You Looking for Balance Transfer?"
                          options={[
                            { value: "Yes", label: "Yes" },
                            { value: "No", label: "No" },
                          ]}
                          registerOptions={{
                            required: "Selection is required",
                          }}
                          error={errors.is_pf_deducted?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledInput
                          name="hospital_address"
                          label="Hospital Address"
                          registerOptions={{
                            required: "Hospital address is required",
                          }}
                          required
                          error={errors.hospital_address?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="hospital_state"
                          label="Hospital State"
                          options={stateOptions}
                          value={getSelectedHospitalStateValue()}
                          onChange={handleHospitalStateChange}
                          registerOptions={{ required: "State is required" }}
                          error={errors.hospital_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelect
                          name="hospital_city"
                          label="Hospital City"
                          options={hospitalCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.hospital_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <LabeledSelectAgent
                          name="hospital_pincode"
                          label="Hospital Pincode"
                          options={hospitalPincodeOptions}
                          registerOptions={{ required: "Pincode is required" }}
                          error={errors.hospital_pincode?.message}
                        />
                      </Col>
                    </>
                  )}
                  <Col md={6}>
                    <LabeledDropDown
                      name="add_reference"
                      label="Add Reference"
                      options={[
                        { value: "Colleague", label: "Colleague" },
                        { value: "Relative", label: "Relative" },
                      ]}
                    />
                  </Col>

                  <h4>Reference Details</h4>
                  <Col md={6}>
                    <LabeledInput name="reference_name" label="Name" />
                  </Col>
                  <Col md={6}>
                    <LabeledInput
                      name="reference_mobile"
                      label="Mobile"
                      type="tel"
                    />
                  </Col>
                  <Col md={6}>
                    <LabeledInput name="reference_address" label="Address" />
                  </Col>
                  <Col md={6}>
                    <LabeledInput name="reference_location" label="Location" />
                  </Col>
                </Row>
              </div>
            )}

            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    <div className="document-upload-group">
                      <label
                        htmlFor="photo"
                        className="document-label required"
                      >
                        Photo(Selfie)
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.photo}
                          label="Photo"
                          type="file"
                          name="photo"
                          className="form-control-file"
                          onChange={handleFileChange}
                        />
                        {files.photo && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("photo")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("photo")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("photo")}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <label
                        htmlFor="aadhar_card"
                        className="document-label required"
                      >
                        Aadhaar/eAadhaar
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.aadhar_card}
                          label="Aadhar Card"
                          type="file"
                          name="aadhar_card"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.aadhar_card && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("aadhar_card")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("aadhar_card")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("aadhar_card")}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <label
                        htmlFor="pan_card"
                        className="document-label required"
                      >
                        PAN Card
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.pan_card}
                          label="PAN Card"
                          type="file"
                          name="pan_card"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.pan_card && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("pan_card")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("pan_card")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("pan_card")}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <label
                        htmlFor="salaried_account_statement"
                        className="document-label required"
                      >
                        {watch("work_type") === "Salaried" ? (
                          <>
                            Account Statement <br /> (Last 6 Months)
                          </>
                        ) : (
                          <>
                            Account Statement <br /> (Last 12 Months)
                          </>
                        )}
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.salaried_account_statement}
                          type="file"
                          name="salaried_account_statement"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.salaried_account_statement && (
                            <FaTrashAlt
                              className="trash-icon"
                              title="Remove file"
                              onClick={() => handleClearFile("salaried_account_statement")}
                            />
                          )}
                      </div>
                      <div className="button-group">
                      <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("salaried_account_statement")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("salaried_account_statement")}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                    {watch("work_type") === "Salaried" && (
                      <>
                        <div className="document-upload-group">
                          <label htmlFor="payslip" className="document-label">
                            Pay Slip (Last 3 Months)
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.payslip}
                              type="file"
                              name="payslip"
                              onChange={handleFileChange}
                              className="form-control-file"
                            />
                            {files.payslip && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("payslip")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                          <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("payslip")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("payslip")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                    {watch("work_type") === "Own Clinic" && (
                      <>
                        <div className="document-upload-group">
                          <label
                            htmlFor="itr"
                            className="document-label"
                          >
                            ITR Last 2 Years
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.itr}
                              type="file"
                              name="itr"
                              onChange={handleFileChange}
                              className="form-control-file"
                            />
                            {files.itr && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("itr")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                          <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("itr")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("itr")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                        <div className="document-upload-group">
                          <label
                            htmlFor="clinic_registration_certificate"
                            className="document-label"
                          >
                            Clinic Registeration
                          </label>
                          <div className="document-file-container">
                            <input
                              ref={fileRefs.clinic_registration_certificate}
                              type="file"
                              name="clinic_registration_certificate"
                              onChange={handleFileChange}
                              className="form-control-file"
                            />
                            {files.clinic_registration_certificate && (
                              <FaTrashAlt
                                className="trash-icon"
                                title="Remove file"
                                onClick={() => handleClearFile("clinic_registration_certificate")}
                              />
                            )}
                          </div>
                          <div className="button-group">
                          <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleViewClick("clinic_registration_certificate")}
                            >
                              View
                            </button>
                            <button
                              type="button"
                              className="view-btn"
                              onClick={() => handleDownloadClick("clinic_registration_certificate")}
                            >
                              Download
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="document-upload-group">
                      <label
                        htmlFor="degree_certificate"
                        className="document-label"
                      >
                        Degree Certificate
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.degree_certificate}
                          type="file"
                          name="degree_certificate"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.degree_certificate && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("degree_certificate")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("degree_certificate")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("degree_certificate")}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <label
                        htmlFor="ima_certificate"
                        className="document-label"
                      >
                        IMA Registration
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.ima_certificate}
                          type="file"
                          name="ima_certificate"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.ima_certificate && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("ima_certificate")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("ima_certificate")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("ima_certificate")}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                    <div className="document-upload-group">
                      <label
                        htmlFor="others"
                        className="document-label"
                      >
                        Others
                      </label>
                      <div className="document-file-container">
                        <input
                          ref={fileRefs.others}
                          type="file"
                          name="others"
                          onChange={handleFileChange}
                          className="form-control-file"
                        />
                        {files.others && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("others")}
                          />
                        )}
                      </div>
                      <div className="button-group">
                      <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleViewClick("others")}
                        >
                          View
                        </button>
                        <button
                          type="button"
                          className="view-btn"
                          onClick={() => handleDownloadClick("others")}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container">
            <Row className="mt-4">
              <Col className="text-end">
                {activeStep > 0 && (
                  <Button
                    variant="secondary"
                    onClick={() => handleStepChange(activeStep - 1)}
                    className="custom-back-button"
                  >
                    Go Back
                  </Button>
                )}
                {activeStep < steps.length - 1 && (
                  <Button
                    variant="primary"
                    onClick={() => handleStepChange(activeStep + 1)}
                    className="custom-next-button"
                  >
                    Next Step
                  </Button>
                )}
                {activeStep === steps.length - 1 &&
                  !(adminRole === "customer" && selectedStatus === "Approved") && (
                  <Button
                    type="submit"
                    variant="primary"
                    className="custom-submit-button"
                  >
                    {loading ? "Processing..." : "Update"}
                  </Button>
                )}
              </Col>
            </Row>
          </div>
        </form>
      </FormProvider>
      <ToastContainer />
    </div>
  );
};

export default EditDoctorLoan;
